<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="title"
    width="400px"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    class="main-content warehouse-dialog"
  >
    <div class="section" style="width: 100%">
      <el-form
        label-position="left"
        label-width="80px"
        style="width: 100%;"
      >
        <el-form-item v-if="type === 'in'" :label="$t('Warehouse.StorageDay')">
          <el-date-picker
            ref="arriveStorageDate"
            v-model="inData.arriveStorageDate"
            type="date"
            value-format="yyyy-MM-dd"
            clearable
          />
        </el-form-item>
        <el-form-item v-if="type === 'out'" :label="$t('Warehouse.DeliveryDay')">
          <el-date-picker
            ref="deliverDate"
            v-model="outData.deliverDate"
            type="date"
            value-format="yyyy-MM-dd"
            clearable
          />
        </el-form-item>
        <el-form-item v-if="type === 'out'" :label="$t('SeaExport.Remarks')">
          <el-input v-model="outData.deliverRemarks" type="textarea" />
        </el-form-item>
        <el-form-item v-if="type === 'in'" :label="$t('SeaExport.Remarks')">
          <el-input v-model="inData.arriveStorageRemarks" type="textarea" />
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" style="margin: 0 auto;width: fit-content;">
      <el-button type="primary" @click="okHandler">{{ $t('SeaExport.Confirm') }}</el-button>
      <el-button type="default" @click="onCancel">{{ $t('SeaExport.Cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'InOrOutWarehouseForm',
  props: {
    visible: {
      type: Boolean,
      default: () => false
    },
    title: { type: String, default: () => '' },
    type: { type: String, default: () => '' }
  },
  data() {
    return {
      inData: {},
      outData: {}
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.inData = {}
        this.outData = {}
        if (!val) {
          this.$emit('close', val)
        } else {
          this.$emit('open', val)
        }
      }
    }
  },
  methods: {
    onCancel() {
      this.$emit('close')
    },
    okHandler() {
      if (this.type === 'in' && !this.inData.arriveStorageDate) {
        this.$message.warning(this.$t('Warehouse.StorageDayCanNotBeNull'))
        this.$refs['arriveStorageDate'].focus()
        return
      }
      if (this.type === 'out' && !this.outData.deliverDate) {
        this.$message.warning(this.$t('Warehouse.DeliveryDayCanNotBeNull'))
        this.$refs['deliverDate'].focus()
        return
      }
      if (this.type === 'in') {
        const { arriveStorageDate, arriveStorageRemarks } = this.inData
        this.$emit('ok', { arriveStorageDate }, { arriveStorageRemarks }, true)
      }
      if (this.type === 'out') {
        const { deliverDate, deliverRemarks } = this.outData
        this.$emit('ok', { deliverDate }, { deliverRemarks }, false)
      }
    }
  }
}
</script>

<style scoped>

</style>
